import i18n from "i18n";

const columns = [
  {
    name: "name",
    pill: false,
    title: i18n.t("name").toUpperCase(),
    mobileTag: false,
  },
  {
    name: "type",
    pill: false,
    title: i18n.t("type").toUpperCase(),
    mobileTag: `${i18n.t("type")}:`,
  },
  {
    name: "serial_number",
    pill: false,
    title: i18n.t("serial.number").toUpperCase(),
    mobileTag: `${i18n.t("number.abbreviated")}:`
  },

  {
    name: "node",
    pill: false,
    title: i18n.t("branch.office").toUpperCase(),
    mobileTag: `${i18n.t("branch.office")}:`,
  },

  {
    name: "location",
    pill: false,
    title: i18n.t("location").toUpperCase(),
    mobileTag: `${i18n.t("location")}:`,
  },
  {
    name: "status",
    title: i18n.t("status").toUpperCase(),
    mobileTag: false,
    pill: true,
    pillMap: {
      DIS: i18n.t("disabled"),
      EN: i18n.t("enabled"),
    },
    pillMapColor: {
      DIS: "#3C7AF5",
      EN: "#62D862",
    },
  },
];

export default columns;
